import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" }); // ✅ For success/error msg

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, subject, message, mobile } = formData;

    // Required field check
    if (
      !name.trim() ||
      !email.trim() ||
      !subject.trim() ||
      !message.trim() ||
      !mobile.trim()
    ) {
      setStatus({
        type: "error",
        message: "Please fill in all required fields!",
      });
      return;
    }

    // email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com)$/i;
    if (!emailPattern.test(email)) {
      setStatus({
        type: "error",
        message: "Please enter a valid email address!",
      });
      return;
    }

    // Mobile number
    if (mobile.replace(/\D/g, "").length < 10) {
      setStatus({
        type: "error",
        message: "Please enter a valid mobile number!",
      });
      return;
    }

    // Send data to backend API
    try {
      const res = await fetch("http://localhost:3001/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      // http://192.168.0.175:3001/api/contact

      const data = await res.json();
      if (res.ok) {
        setStatus({
          type: "success",
          message:
            data.message ||
            "Thanks for reaching out! We’ll get back to you soon.",
        });

        // Reset form
        setFormData({
          name: "",
          email: "",
          mobile: "",
          subject: "",
          message: "",
        });
      } else {
        setStatus({
          type: "error",
          message: data.error || "Error saving data!",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: "Server error, please try again later.",
      });
      console.error(error);
    }
  };

  return (
    <div className="container" style={{ marginTop: 0, paddingTop: 0 }}>
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <h1 className="mb-4 text-center">Reach Us</h1>

          <div className="card shadow-sm p-4">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Your Name *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Your Email *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <PhoneInput
                  country={"in"}
                  value={formData.mobile}
                  onChange={(phone) =>
                    setFormData({ ...formData, mobile: phone })
                  }
                  inputProps={{
                    name: "mobile",
                    required: true,
                    className: "form-control",
                  }}
                  enableSearch
                />
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  placeholder="Subject *"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-4">
                <textarea
                  className="form-control"
                  name="message"
                  placeholder="Message *"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="text-center">
                <button type="submit" className="btn btn-primary px-4 py-2">
                  Send Message
                </button>
              </div>
            </form>

            {status.message && (
              <p
                className="mt-3 text-center"
                style={{ color: status.type === "success" ? "green" : "red" }}
              >
                {status.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
